export const InactiveUserIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M17.2519 9.99982C17.2519 14.0017 14.0033 17.2501 10.0009 17.2501C5.99858 17.2501 2.75 14.0017 2.75 9.99982C2.75 5.99792 5.99858 2.74951 10.0009 2.74951C14.0033 2.74951 17.2519 5.99792 17.2519 9.99982Z"
				stroke="#888DA6"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.9995 4.91676L4.91748 14.9995"
				stroke="#888DA6"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
